export default "__VITE_ASSET__Cg43aJYk__"